"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.videoPropType = exports.linkPropType = exports.imagePropType = exports.featurePropType = exports["default"] = exports.ctaPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var videoPropType = _propTypes["default"].shape({
  source: _propTypes["default"].string,
  autoplay: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  loop: _propTypes["default"].bool
});
exports.videoPropType = videoPropType;
var ctaPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string
});
exports.ctaPropType = ctaPropType;
var linkPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string
});
exports.linkPropType = linkPropType;
var featurePropType = _propTypes["default"].shape({
  image: imagePropType,
  description: _propTypes["default"].string,
  icons: _propTypes["default"].string
});
exports.featurePropType = featurePropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  layout: _propTypes["default"].string,
  heading1: _propTypes["default"].string,
  heading2: _propTypes["default"].string,
  heading3: _propTypes["default"].string,
  textBlock: _propTypes["default"].string,
  textBlockPosition: _propTypes["default"].string,
  featureBlock: _propTypes["default"].arrayOf(featurePropType),
  cta: ctaPropType,
  link: linkPropType,
  backgroundImage: imagePropType,
  image: imagePropType,
  video: videoPropType,
  navigationLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string,
    label: _propTypes["default"].string,
    openNewTab: _propTypes["default"].bool
  })),
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
var _default = PROP_TYPES;
exports["default"] = _default;